// @ts-check

import Network from 'infrastructure/js/modules/network';
import ScheduleAction from '../../../../mat/js/modules/scheduleAction';
import * as schedulerService from '../../services/Scheduler/schedulerService';


export default class GanttPostValidationTimer {

  /////////////////////
  // Singleton
  //

  /** @type { GanttPostValidationTimer | null } */
  static #instance = null;

  static getInstance() {
    if (GanttPostValidationTimer.#instance == null) {
      GanttPostValidationTimer.#instance = new GanttPostValidationTimer();
    }
    return GanttPostValidationTimer.#instance;
  }


  constructor() {
  }


  //////////////////////
  // Settings
  //
  
  #LOGGING_ENABLED = false;
  
  TIMER_KEY = 'scheduler-async-validation-checker';
  POLLING_LIMIT_SEC = 60 * 10; // 10 minutes
  POLLING_INTERVAL_SEC = 1;
  START_IMMEDIATELY = true;




  /** @type { { kill: () => void; } | null | undefined } */
  timer = null;

  /** @type { number | null } */
  startedAtEpochMs = null;




  /**
   * @param {number} jobExecutionId
   * @param {Function} fnOnComplete
   */
  start = (jobExecutionId, fnOnComplete) => {
    this.#log('--- STARTING TIMER ===> ',);

    if (!jobExecutionId) {
      console.error('No Job Execution Id Provided, cannot start timer');
      return;
    }

    if (this.timer) {
      console.warn('Stopping existing timer');
      this.stop();
    }

    this.startedAtEpochMs = Date.now();

    this.timer = ScheduleAction(
      this.TIMER_KEY,
      () => {
        this.worker(jobExecutionId, fnOnComplete);
      },
      this.POLLING_INTERVAL_SEC,
      this.START_IMMEDIATELY
    );

    // console.log('asyncValidationTimer ===> ', asyncValidationTimer);
  }

  stop() {
    this.#log('--- STOPPING TIMER ===> ',);
    this.timer?.kill();
    this.timer = null;
    this.startedAtEpochMs = null;
  }



  /**
   * @param {number} jobExecutionId
   * @param {Function} fnOnComplete
   */
  worker = async (jobExecutionId, fnOnComplete) => {
    this.#log(' ===> WORKER ===> ', );

    // Check for timeout
    if (this.#isTimeoutReached()) {
      this.#log('--- TIMEOUT REACHED, STOPPING TIMER ===> ',);
      this.stop();
      return;
    }
    
    
    let response = null;
    try {
      response = await schedulerService.fetchAsyncValidationJobStatus(jobExecutionId);
      if (!Network.isResponseValid(response)) {
        console.error('Fetch Async Validation Status Failed', response);
        this.stop();
        return;
      }
    } catch (error) {
      console.error('Fetch Async Validation Status Failed', error);
      this.stop();
      return;
    }
    
    
    let status = response?.data?.jobStatus;
    this.#log('status ===> ', status);

    let isFinished = this.#isJobFinished(status);
    if (isFinished) {
      this.stop();
      fnOnComplete?.();
    }



  }



  #isTimeoutReached = () => {
    if (!this.startedAtEpochMs) {
      return false;
    }
    let nowMs = Date.now();
    let elapsedSec = (nowMs - this.startedAtEpochMs) / 1000;
    return elapsedSec > this.POLLING_LIMIT_SEC;
  }


  /**
   * @param {string} status
   */
  #isJobFinished = (status) => {
    return status === 'COMPLETED' || status === 'STOPPED' || status === 'FAILED' || status === null;
  }
  
  
  /**
   * @param {any} args
   */
  #log = (...args) => {
    if (!this.#LOGGING_ENABLED) {
      return;
    }
    console.log('[Timer]', ...args);
  }

}




